import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";

const globalStyles = createGlobalStyle`
${reset};


@import url('https://fonts.googleapis.com/css?family=Baloo+Bhai|Jua&display=swap');
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
    -webkit-text-fill-color: white;
    -webkit-box-shadow: 0 0 0px 1000px #000 inset;
}

::selection {
   background: rgba(255, 255, 255, 1);
}


a{
    text-decoration:none;
    color:inherit

}

*{
    box-sizing:border-box;
}

button {
    outline: none;
border: none;
}

input {
    border: none;
    outline: none;
}

textarea {
    border:none;
    outline:none;
    resize: none;
    &:focus {
        border:none;
        outline:none;
    }
}


[contenteditable=true]:empty:before{
  content: attr(placeholder);
  display: block; /* For Firefox */
  opacity: 0.3;
  -webkit-user-select: text;
    user-select: text;
}

div[contenteditable=true] {
    -webkit-user-select: text;
    user-select: text;
    border:none;
    outline:none;
    resize: none;
    &:focus {
        border:none;
        outline:none;
    }
}

body{
    font-family:-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    font-size: 14px;
    background-color:#0063EB;
    overflow-x: hidden;
}

@media (min-width: 320px) and (max-width: 480px) {
    #saveBtn {
   display: none; 
}
  }


/* html,body, #root, .fadeIn {
  height:100%;
} */

.disableDrag{
    -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none;
}

.fadeIn {
    animation-duration: 1s;
    -moz-animation-duration: 1s;
  -webkit-animation-duration: 1s;
    animation-name: fadeInUp;
    -moz-animation-name: fadeInUp;
  -webkit-animation-name: fadeInUp;
    position: relative;
}

@-moz-keyframes fadeInUp {
    from { opacity: 0.3; bottom: -15px}
    to { opacity:1; bottom:0}
}

@-webkit-keyframes fadeInUp {
    from { opacity: 0.3; bottom: -15px}
    to { opacity:1; bottom:0}
}

@keyframes fadeInUp {
    from { opacity: 0.3; bottom: -15px}
    to { opacity:1; bottom:0}
}

`;

export default globalStyles;
